import React from "react";
import styles from "./styles/ServiceCentreHero.module.css";
import heroBg from "../../../images/Mechatronics.jpg";

export default function ServiceCentreHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>Authorised Service Centre</h1>
          <p className={styles.description}>Armed for productivity</p>
        </div>
      </div>
    </section>
  );
}
